import { registerPlugin } from '@capacitor/core'
import type {
    EventrCapacitorCalendarPlugin,
    PushNotificationsPlugin,
} from './definitions'

const PushNotifications = registerPlugin<PushNotificationsPlugin>(
    'PushNotifications',
    {}
)

export * from './definitions'
export { PushNotifications }

const EventrCapacitorCalendar = registerPlugin<EventrCapacitorCalendarPlugin>(
    'EventrCapacitorCalendar'
)

export * from './definitions'
export { EventrCapacitorCalendar }
